import { createAsyncThunk } from '@reduxjs/toolkit';
import { CountryCode } from '@/Enums';
import { GeneratorCountryZonesApi } from '@/Api/GeneratorCountryZones/GeneratorCountryZonesApi';
import { CreateGeneratorCountryZoneResponse } from '@/Api/GeneratorCountryZones/Responses/CreateGeneratorCountryZoneResponse';
import { CreateGeneratorCountryZoneRequest } from '@/Api/GeneratorCountryZones/Requests/CreateGeneratorCountryZoneRequest';
import { UpdateGeneratorCountryZoneResponse } from '@/Api/GeneratorCountryZones/Responses/UpdateGeneratorCountryZoneResponse';
import { UpdateGeneratorCountryZoneRequest } from '@/Api/GeneratorCountryZones/Requests/UpdateGeneratorCountryZoneRequest';
import { GetAllGeneratorCountryZoneByCountryResponse } from '@/Api/GeneratorCountryZones/Responses/GetAllGeneratorCountryZoneByCountryResponse';

const getGeneratorCountryZonesRequest = createAsyncThunk<GetAllGeneratorCountryZoneByCountryResponse, CountryCode>(
  'generatorCountryZones/get-generator-country-zones',
  async (request) => {
    return await GeneratorCountryZonesApi.getGeneratorCountryZonesGroupedByCountry(request);
  },
);

const createGeneratorCountryZoneRequest = createAsyncThunk<
  CreateGeneratorCountryZoneResponse,
  CreateGeneratorCountryZoneRequest
>('generatorCountryZones/create-generator-country-zone', async (request) => {
  return await GeneratorCountryZonesApi.createGeneratorCountryZone(request);
});

const updateGeneratorCountryZoneRequest = createAsyncThunk<
  UpdateGeneratorCountryZoneResponse,
  UpdateGeneratorCountryZoneRequest
>('generatorCountryZones/update-generator-country-zone', async (request) => {
  return await GeneratorCountryZonesApi.updateGeneratorCountryZone(request);
});

const deleteGeneratorCountryZoneRequest = createAsyncThunk<number, number>(
  'generatorCountryZones/delete-generator-country-zone',
  async (id) => {
    return GeneratorCountryZonesApi.deleteGeneratorCountryZone(id);
  },
);

export const asyncActions = {
  getGeneratorCountryZonesRequest,
  createGeneratorCountryZoneRequest,
  updateGeneratorCountryZoneRequest,
  deleteGeneratorCountryZoneRequest,
};
